module.exports = __webpack_public_path__ + "static/media/brand17.d7e2b400.png";